var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
var toDisplayName = function (name) {
    return name.replace(/[A-Za-z]+/g, function (word) { return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); });
};
export var PackerBadge = function (_a) {
    var packerName = _a.packerName, _b = _a.isMine, isMine = _b === void 0 ? false : _b, _c = _a.withLabel, withLabel = _c === void 0 ? false : _c, _d = _a.isSelected, isSelected = _d === void 0 ? false : _d;
    var t = useTranslation().t;
    if (!packerName)
        return null;
    var displayName = toDisplayName(packerName);
    var tone = isSelected
        ? 'text-blue-100'
        : isMine
            ? 'text-gray-400'
            : 'text-amber-600';
    return (_jsxs("span", __assign({ "data-testid": 'packer-badge', "data-mine": isMine ? 'true' : 'false', className: "inline-flex items-center gap-1 whitespace-nowrap font-medium " + tone, style: { fontSize: 10, lineHeight: '16px', maxWidth: 180 }, title: withLabel ? t('Packed by') + " " + displayName : displayName }, { children: [_jsx(UserOutlined, { style: { fontSize: 9 } }, void 0), _jsx("span", __assign({ className: 'truncate' }, { children: withLabel ? t('Packed by') + " " + displayName : displayName }), void 0)] }), void 0));
};
export default PackerBadge;
